export const books = [
  {
    id: 1,
    title: 'Clean Code',
    review:
      "some solid advice if you're early in your dev journey - but a few takes are kinda outdated.",
    image: './assets/icons/books/clean_code.png',
  },
  {
    id: 2,
    title: 'The DevOps Handbook',
    review:
      'still working through it - but already getting some solid insight into scaling and delivery.',
    image: './assets/icons/books/devops_handbook.png',
  },
  {
    id: 3,
    title: 'Fundamentals of Software Architecture',
    review:
      'really liked how it breaks down architecture trade-offs without sounding biased and explained it in a simple fashion.',
    image: './assets/icons/books/fundamentals_of_software_architecture.png',
  },
  {
    id: 4,
    title: 'Modern Software Engineering',
    review: 'haven’t started this one yet, it’s chilling in the backlog',
    image: './assets/icons/books/modern_soft_eng.png',
  },
];
